import React from "react";
import SettingContent from "../components/Setting/Setting";
import MainLayout from "../components/MainLayout/MainLayout";

function Setting() {
  return (
    <MainLayout>
      <SettingContent />
    </MainLayout>
  );
}

export default Setting;